import { DeeplinkRecommendation, RBAssetEntityType } from '../../types';

function isDeeplinkRecommendationItem(
    item: any,
): item is DeeplinkRecommendation {
    return item.entityType === RBAssetEntityType.DeeplinkRecommendation;
}

export default isDeeplinkRecommendationItem;
